export default "__VITE_ASSET__0d5765b2__"